// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sYit","disabled":"styles_disabled__I4882"};